const replaceObjectKeys = (arr, key) => {
    var data = {};
    arr.forEach(x => data[x[key]] = x);
    return data;
};

export default {
    replaceObjectKeys
};
